import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2, Mail, Lock, User } from "lucide-react";
import { toast } from "sonner";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { AuthShell } from "@/pages/auth/AuthShell";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await register(name, email, password);
      toast.success("Account created — check your email to verify");
      navigate("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <AuthShell title="Join MedLync" subtitle="Create a free account to publish, comment and join communities.">
      <form onSubmit={submit} className="space-y-3">
        <div className="relative">
          <User className="absolute left-3 top-3 h-4 w-4 text-slate-400" />
          <Input data-testid="register-name-input" value={name} onChange={(e) => setName(e.target.value)} placeholder="Full name" className="pl-9" required />
        </div>
        <div className="relative">
          <Mail className="absolute left-3 top-3 h-4 w-4 text-slate-400" />
          <Input data-testid="register-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="pl-9" required />
        </div>
        <div className="relative">
          <Lock className="absolute left-3 top-3 h-4 w-4 text-slate-400" />
          <Input data-testid="register-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password (min 6 chars)" className="pl-9" required />
        </div>
        {error && <p className="text-sm text-red-600">{error}</p>}
        <Button data-testid="register-submit-button" type="submit" disabled={busy} className="w-full bg-medorange hover:bg-medorange-hover">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Create account"}
        </Button>
      </form>
      <p className="mt-4 text-center text-sm text-slate-500">Already a member? <Link to="/login" className="font-semibold text-medorange">Sign in</Link></p>
    </AuthShell>
  );
}
